import type { RouteMeta } from 'vue-router'

import PATHS from '@/router/paths'

export type AffiliateGuardDecision =
  | { action: 'next' }
  | { action: 'redirect'; to: string }
  | { action: 'fallthrough' }

/**
 * Pré-passo do beforeResolve (spec §4.5): separa as personas antes do fluxo de
 * gestão. Um e-mail = uma persona (Q26), então nunca há os dois tokens juntos
 * (cada login faz clearAuthStorage).
 */
export function resolveAffiliateGuard(
  meta: Pick<RouteMeta, 'requiresAffiliateAuth' | 'requiresCompanyUserAuth'>,
  state: { affiliateAuthenticated: boolean; companyAuthenticated: boolean; enabled: boolean }
): AffiliateGuardDecision {
  if (meta.requiresAffiliateAuth) {
    if (state.affiliateAuthenticated) return { action: 'next' }
    if (state.companyAuthenticated) return { action: 'redirect', to: PATHS.DASHBOARD }
    return { action: 'redirect', to: PATHS.SIGNIN }
  }
  if (
    meta.requiresCompanyUserAuth &&
    state.enabled &&
    !state.companyAuthenticated &&
    state.affiliateAuthenticated
  ) {
    return { action: 'redirect', to: PATHS.AFFILIATE_OVERVIEW }
  }
  return { action: 'fallthrough' }
}
